

















































































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import ImmersiveNavbar from '@/dex-shared/components/ImmersiveNavbar.vue';

export default Vue.extend({
  components: {
    ImmersiveNavbar,
  },
  data() {
    return {
      activeIndex: null,
      sections: [
        {
          title: 'Temas',
          link: '/',
          name: 'home',
        },
        {
          title: 'Rascunhos',
          link: '/rascunhos',
          name: 'drafts',
        },
        {
          title: 'Correções',
          link: '/correcoes',
          name: 'corrections',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state: any) => state.auth.user,
    }),
    ...mapGetters({
      userEssayCredits: 'userEssayCredits',
    }),
    creditsMessage() {
      let { userEssayCredits } = this;
      return `${userEssayCredits}${
        userEssayCredits == 1 ? 'crédito' : 'créditos'
      }`;
    },
    focusPage(): boolean {
      return this.$route.path === '/comprar-creditos';
    },
  },
  watch: {
    $route(route) {
      let newActiveIndex = this.findActiveIndex(route);
      if (newActiveIndex != -1) {
        this.activeIndex = newActiveIndex;
      }
    },
  },
  created() {
    if (this.user) {
      this.$store.dispatch('PULL_USER_ESSAY_CREDITS');
    }
    this.activeIndex = this.findActiveIndex(this.$route);
  },
  methods: {
    findActiveIndex(route = {}) {
      return this.sections.indexOf(
        this.sections.find(s => s.name == (route as any).name),
      );
    },
    noCredits(balance) {
      return balance <= 0;
    },
  },
});
